import { useSelector } from 'react-redux';
import { getPlanPaymentFrequency } from '../../../store/policystreamStore';
import { CoreQuotePolicystreamPlanPaymentFrequencyChoices as PlanPaymentFrequencyChoices } from '../../../gql/graphql';

export const usePolicyStreamPlanPaymentFrequency = () => {
  const planPaymentFrequency = useSelector(getPlanPaymentFrequency);

  return {
    monthly: planPaymentFrequency === PlanPaymentFrequencyChoices.Monthly,
    annually: planPaymentFrequency === PlanPaymentFrequencyChoices.Annually,
  };
};
